<template>
  <header class="ftn-header landing-header">
    <div class="ftn-container landing-header__container">
      <TrybLogo
        class="landing-header__logo"
        @click="goToHomepage"
      />
      <TButton
        variant="orange"
        @click="goToHomepage"
      >
        Go to Tryb
      </TButton>
    </div>
  </header>
</template>

<script>

import TrybLogo from '@/assets/icons/optimized/tryb_logo.svg?inline';
import TButton from '@/components/base/TButton/TButton.vue';

export default {
  name: 'LandingHeader',
  components: {
    TButton,
    TrybLogo,
  },
  methods: {
    goToHomepage() {
      this.$router.push({ name: 'Homepage' });
    },
  },
};
</script>

<style
  scoped
  lang="scss"
>
@import "~@/assets/scss/mixins";

.landing-header {
  position: fixed;
  right: 0;
  left: 0;
  top: 0;
  z-index: var(--zindex-fixed);

  &__container {
    display: flex;
    justify-content: space-between;
  }

  &__logo {
    width: 48px;
    height: 38px;

    cursor: pointer;

    @include media-lg() {
      width: 78px;
      height: 48px;
    }
  }
}
</style>
